
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.92 1.32a6.6 6.6 0 110 13.2 6.6 6.6 0 010-13.2zm0 1.2a5.4 5.4 0 100 10.8 5.4 5.4 0 000-10.8zm0 1.2a.6.6 0 01.6.6v3.351l1.624 1.625a.6.6 0 01-.848.848l-1.8-1.8a.6.6 0 01-.176-.424v-3.6a.6.6 0 01.6-.6z"}})])
          )
        }
      }
    